(function () {
    'use strict';

    angular.module('nfseApp')
        .controller('LoteRPSDetailController', function ($scope, $rootScope, $stateParams,
                                                         entity, LoteRPS, $timeout, RPS, ParseLinks, Notificacao) {

            $scope.loteRPS = entity;
            $scope.editable = false;
            $scope.page = 0;
            $scope.searchQuery = '';
            $scope.per_page = 50;

            $scope.editorOptions = {
                lineWrapping: true,
                lineNumbers: true,
                readOnly: 'nocursor',
                mode: 'htmlmixed',
                lineSeparator: '</br>'
            };

            $scope.loadPage = function (page) {
                $scope.page = page;
                $scope.carregarRps();
            };

            $scope.load = function (id) {
                LoteRPS.get({id: id}, function (result) {
                    $scope.loteRPS = result;
                    $scope.carregarXml();
                    $scope.carregarLog();
                    $scope.verificarSituacaoLote();
                });
            };

            $scope.load($scope.loteRPS.id);

            $scope.verificarSituacaoLote = function() {
                $scope.carregarXml();
                if ($scope.loteRPS.situacao === 'AGUARDANDO') {
                    $scope.timeout = $timeout(function () {
                        $scope.load($scope.loteRPS.id);
                    }, 5000);
                } else {
                    $scope.carregarRps();
                }
            };

            $scope.reprocessarLote = function () {
                LoteRPS.reprocessar($scope.loteRPS, function () {
                    Notificacao.info("Informação", "Lote enviado para reprocessamento!");
                    $scope.load($scope.loteRPS.id);
                }, function () {
                    $scope.load($scope.loteRPS.id);
                });
            };

            $scope.$on('$destroy', function () {
                $timeout.cancel($scope.timeout);
            });
        });
})();
